// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__2bvyg","head":"ProcedureTableInfo_head__25SEF"};